import { createContext, FC, PropsWithChildren, useEffect, useMemo, useState } from 'react';

import useGetAssignedApplications from '@api/useGetAssignedApplications/useGetAssignedApplications';

import { IAssignedApplicationsContext } from './assignedApplicationsContext.interface';

const AssignedApplicationsContext = createContext<IAssignedApplicationsContext | undefined>(undefined);

const AssignedApplicationsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isAssignedApplicationsLoading, setIsAssignedApplicationsLoading] = useState(false);
  const [assignedApplications, setAssignedApplications] = useState<string[]>([]);
  const {
    makeRequestHandler: getAssignedApplications,
  } = useGetAssignedApplications({
    callbacks: {
      setIsLoading: setIsAssignedApplicationsLoading,
      setData: (data: unknown) => setAssignedApplications(data as string[]),
    },
  });

  useEffect(() => {
    getAssignedApplications();
  }, []);

  const values = useMemo(() => ({
    assignedApplications,
    isMoreThanOneAssignedApplication: assignedApplications?.length > 1,
    isAssignedApplicationsLoading,
  }), [
    assignedApplications,
    isAssignedApplicationsLoading,
  ]);

  return (
    <AssignedApplicationsContext.Provider value={values}>
      {children}
    </AssignedApplicationsContext.Provider>
  );
};

export { AssignedApplicationsProvider, AssignedApplicationsContext };
